import React, {Component} from 'react';
import {Field} from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import {
  Checkbox,
  TextField,
} from 'redux-form-material-ui';

const ChevronRight = require('react-icons/lib/md/chevron-right');

const contentStyle = {
  margin: 20,
  contentAlign: 'left',
  textAlign: 'left',
  display: 'inline-block',
};

const renderTextField = (field) => (
  <div className="input-row">
    <TextField {...field} errorText={field.meta.touched && field.meta.error} onChange={field.input.onChange}/>
  </div>
);

class ParentForm extends Component {
  render() {
    // handleSubmit wird vom redux-form decorator in die Props geschrieben.
    const {
      handleSubmit,
      isInternalUse,
      viewportWidth,
    } = this.props;

    return (
      <form>
        <div>
          <h1>Ratzgiwatz Jugendprogramm Web-Anmeldung</h1>
          <h3>Eingabe Ihrer Daten <em>als Erziehungsberechtigter</em></h3>
          <div style={contentStyle}>
            <Field
              autoFocus
              name="vorname"
              floatingLabelText="Vorname Erziehungsberechtigter"
              component={renderTextField}
            />
            <Field
              name="nachname"
              floatingLabelText="Nachname Erziehungsberechtigter"
              component={renderTextField}
            />
            <Field
              name="strasse"
              floatingLabelText="Straße und Hausnummer"
              component={renderTextField}
            />
            <Field
              name="plz"
              floatingLabelText="Postleitzahl"
              component={renderTextField}
            />
            <Field
              name="ort"
              floatingLabelText="Ort"
              component={renderTextField}
            />
            <Field
              name="email"
              floatingLabelText="E-Mail Adresse"
              component={renderTextField}
            />
            {isInternalUse || <Field
              name="email2"
              floatingLabelText="Wiederholung E-Mail Adresse"
              component={renderTextField}
            />}
            <Field
              name="telefon[0]"
              floatingLabelText="Telefon privat"
              component={renderTextField}
            />
            <Field
              name="telefon[1]"
              floatingLabelText="Telefon mobil"
              component={renderTextField}
            />
            <Field
              name="telefon[2]"
              floatingLabelText="Telefon geschaeftlich"
              component={renderTextField}
            />
          </div>
          <div>
            <Field
              name="einverstaendnisWaehrendDerWoche"
              component={Checkbox}
              label={viewportWidth > 480 ? "Ich willige ein, dass mich Ratzgiwatz e.V. während der diesjährigen Ratzgiwatz-Woche per E-Mail über die Ratzgiwatz-Woche infomiert.\n\nMeine Daten werden ausschließlich zu diesem Zweck genutzt.\n\nEine Weitergabe an Dritte erfolgt nicht.\n\nIch kann die Einwilligung jederzeit per E-Mail an newsletter@ratzgiwatz.de oder per Post an Sascha Lübbe, Max-Planck-Straße 32, 72379 Hechingen widerrufen." : "Info E-Mails während der Woche."}
            />
          </div>
          <br />
          <RaisedButton
            label={ viewportWidth > 480 ? "Daten des ersten Kindes angeben" : "Weiter"}
            onTouchTap={handleSubmit}
            primary={true}
            icon={<ChevronRight/>}
            href={this.props && this.props.href}
          />
        </div>
      </form>
    );
  }
}

export default ParentForm



// WEBPACK FOOTER //
// ./src/components/parent/ParentForm.jsx